import NewApiService from "@/utils/new.api.service";

export default {
    getByGroup(context, group) {
        return new Promise((resolve, reject) => {
            NewApiService.get(`bexio-link/${group}`)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
    createLink(context, model) {
        return new Promise((resolve, reject) => {
            NewApiService.post(`bexio-link/${model.group}`, model)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            });
        });
    },
}